import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["dispatch"];
import { useEffect, useRef } from 'react';
import { CustomsPerformanceMetricsName, useHistoryInitialize } from '@features/libs';
import { setBuildInfo } from '@ecom-alliance/libs';
import Modal from '@m4b-design/modal';
import { useHistory } from '@jupiter/plugin-runtime/router';
import { AppContext } from '@/hooks/use-app-context';
import { HomeModuleContext, useHomeModuleContext } from '@/hooks/use-home-module-context';
import 'tailwindcss/tailwind.css';
import CheckPermissionRoutes from './routes';
import './App.css';
import { usePrefetchDuringAppExe } from './hooks/use-prefetch-during-app-execute';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export { AppContext as AppRuntimeContext };
performance.mark(CustomsPerformanceMetricsName.LoadSubAppEnd);
setBuildInfo === null || setBuildInfo === void 0 ? void 0 : setBuildInfo(buildInfo);
var App = function App(props) {
  var account = props.account;
  var history = useHistory();
  var _useHomeModuleContext = useHomeModuleContext(),
    dispatch = _useHomeModuleContext.dispatch,
    rest = _objectWithoutProperties(_useHomeModuleContext, _excluded);
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    modal = _Modal$useModal2[0],
    contextHolder = _Modal$useModal2[1];
  var modalRef = useRef({
    modal: modal,
    contextHolder: contextHolder
  });
  useHistoryInitialize({
    history: history,
    region: (account === null || account === void 0 ? void 0 : account.region) || ''
  });
  useEffect(function () {
    performance.mark(CustomsPerformanceMetricsName.BizJsStart);
  }, []);
  usePrefetchDuringAppExe();
  return /*#__PURE__*/_jsx(AppContext.Provider, {
    value: props,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs(HomeModuleContext.Provider, {
        value: _objectSpread(_objectSpread({
          dispatch: dispatch
        }, rest), {}, {
          contextModal: modalRef.current.modal
        }),
        children: [modalRef.current.contextHolder, /*#__PURE__*/_jsx(CheckPermissionRoutes, {})]
      })
    })
  });
};
export default App;